export const MEDIA_TYPE = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO',
  PDF: 'PDF'
};
export const EXTENSION_MEDIA_CONFIG = {
  mp3: MEDIA_TYPE.AUDIO,
  wav: MEDIA_TYPE.AUDIO,
  // Recommendation is to use ogg for audio primarily
  ogg: MEDIA_TYPE.AUDIO,
  jpg: MEDIA_TYPE.IMAGE,
  jpeg: MEDIA_TYPE.IMAGE,
  png: MEDIA_TYPE.IMAGE,
  gif: MEDIA_TYPE.IMAGE,
  mp4: MEDIA_TYPE.VIDEO,
  webm: MEDIA_TYPE.VIDEO,
  pdf: MEDIA_TYPE.PDF
};